<template>
  <ColumnEditModal :value="value" :configName="configName" :columnId="columnId" :editMode="editMode" @input="$emit('input', $event)" v-bind="$attrs">
    <template v-slot:edit-modal-additions="props">
      <v-layout pa-4 wrap>
        <h3> Creating new Mediatypes during Import </h3>
        <v-radio-group column :value="getShouldCreateNewMediatypeValue(props.columnConfiguration)" @change="callSetColumnMetadata(shouldCreateNewMediatypeKey, !(getShouldCreateNewMediatypeValue(props.columnConfiguration)))">
          <v-radio label="Allow Mediatypes to be created in Envirodata when a new Mediatype does not exist during an import" :value="true" />
          <v-radio label="Do not allow Mediatypes to be created and mark the import as unsuccessful when a new Mediatype does not exist during an import" :value="false" />
        </v-radio-group>
        <h3> Delete empty Mediatypes during Rollback </h3>
        <v-radio-group column :value="getShouldDeleteDuringRollbackValue(props.columnConfiguration)" @change="callSetColumnMetadata(shouldDeleteDuringRollbackKey, !(getShouldDeleteDuringRollbackValue(props.columnConfiguration)))">
          <v-radio label="Delete Mediatypes that have no data associated with them during a rollback" :value="true" />
          <v-radio label="Do not delete Mediatypes and mark the rollback as unsuccessful when attempting to delete a Mediatype" :value="false" />
        </v-radio-group>
      </v-layout>
    </template>
  </ColumnEditModal>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')

  import metadataFieldNames from '../../store/metadataFieldNames'
  import ColumnEditModal from './ColumnEditModal'
  export default {
    components: {
      ColumnEditModal,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      configName: {
        type: String,
        required: true,
      },
      columnId: {
        type: String,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        shouldCreateNewMediatypeKey: metadataFieldNames.mediaType_shouldCreateNew,
        shouldDeleteDuringRollbackKey: metadataFieldNames.mediaType_shouldDeleteDuringRollback,
      }
    },
    computed: {},
    methods: {
      ...eddConfiguration.mapActions(['setColumnMetadata']),
      callSetColumnMetadata(metadataFieldName, metadataValue) {
        this.setColumnMetadata({
          configName: this.configName,
          columnId: this.columnId,
          metadataKey: metadataFieldName,
          metadataValue: metadataValue,
        })
      },
      getShouldCreateNewMediatypeValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .shouldCreateNewMediatypeKey]) || false
      },
      getShouldDeleteDuringRollbackValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .shouldDeleteDuringRollbackKey]) || false
      },
    },
  }
</script>

<style scoped>
  .radio-opts {
    padding-bottom: 10px;
  }
</style>